module.exports = __webpack_public_path__ + "static/img/4.cf441f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/Resistance/4.png
// module id = 1AQ9
// module chunks = 1